var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.available)?_c('div',[_c('div',{staticClass:"c-heading-belt--lv1 u-mbxs"},[_vm._v("There’s more!")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.contents)}})]):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }